import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as assets from '../../assets'

export const RESOURCE = {
  payload: {
    description:
      'A financial resource owned by the institution, such as building or equipment.',
    dimension: assets.RESOURCE.payload,
    level: 0,
    name: 'Asset',
    partialId: PartialId.Standard.create('asset'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
